<template>
<slide-transition>
    <Loading v-if="isLoading" />
    <div v-else class="measures-table">
        <div class="flex justify-end mb-4">
            <SearchField @change="filter = $event" />
        </div>
        <MultiSelectTable
            :config="config"
            :data="measures"
            :multiselect="true"
            :selection="selection"
            :filter="filter"
            :filterBy="'name'"
            :sortByKey="'name'"
            :sortDirection="'ASC'"
            :updateSort="() => {}"
            :isRowClickable="() => false"
            :showHeader="false">
            <h2 class="table--no-content" slot="empty-table">{{ $t("No published measures found") }}</h2>

        </MultiSelectTable>
    </div>
</slide-transition>
</template>

<script>
import { fetchKnownMeasuresList } from '@/api/known-measure';
import getConfig from '@/config/known-measures';

import MultiSelectTable from '@/components/shared/form/MultiSelectTable';
import Loading from '@/components/shared/Loading';
import { SlideTransition } from '@/components/shared/transitions';

export default {
    props: ['selection'],
    components: { MultiSelectTable, Loading, SlideTransition },

    data: () => ({
        isLoading: true,
        measures: [],
        filter: '',
    }),

    computed: {
        config () {
            return getConfig(this.$t).slice(0, 2);
        },
    },
    
    created () {
        const selectedUserGroup = this.$store.getters.selectedUserGroup;
        fetchKnownMeasuresList(selectedUserGroup)
        .then(data => {
            this.measures = data.filter(ms => ms.available);
            this.isLoading = false;
        });
    },
};
</script>

<style lang="scss">
.measures-table {
    max-height: 400px;
    overflow-y: auto;
}
</style>
